import { render, staticRenderFns } from "./platformEdit.vue?vue&type=template&id=5e9489aa&scoped=true&"
import script from "./platformEdit.vue?vue&type=script&lang=js&"
export * from "./platformEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9489aa",
  null
  
)

export default component.exports